import React, { useState, useEffect } from "react";
import Axios from '../../utils/api/axiosConf';
import { url } from '../../utils/api/api';
import { RedNotif, GreenNotif } from "../../utils/utils";
import { useParams, useRevalidator, useSearchParams } from "react-router-dom";
import LOADING from "../../components/loading/loading";
import UPLOAD from "../../components/uoload/upload";
import { Col, Row } from "antd";
import { Uploder } from "../../utils/utils";
import INPUT from './../../components/input/input';
import SELECT from "./../../components/select/select";
import BUTTON from "./../../components/buttons/button";
import { color } from "./../../utils/themes/color";
import CHECKBOX from "./../../components/checkBox";
import RADIO from "./../../components/radio/radio";
import TEXTROW from "../../components/textRow";
import UPLOADVIDEO from "../../components/upload-video";


export default function Movements() {

    const queryParams = new URLSearchParams(window.location.search);
    const userId = queryParams.get('id');
    const [loading, setLoading] = useState({ 1: false, 2: false });
    const [user, setUser] = useState({});
    const mainMusclesInvolved = [{ "name": "پشت (پایینی)", "value": "1" }, { "name": "پشت (میانی)", "value": "2" }, { "name": "پشت بازو", "value": "3" }, { "name": "جلو بازو", "value": "4" },
    { "name": "چهارسر", "value": "5" }, { "name": "دورکننده ران", "value": "6" }, { "name": "ذوزنقه", "value": "7" }, { "name": "ساعد", "value": "8" }, { "name": "ساق", "value": "9" },
    { "name": "سرشانه", "value": "10" }, { "name": "سرینی", "value": "11" }, { "name": "سینه", "value": "12" }, { "name": "شکم", "value": "13" }, { "name": "لت", "value": "14" }, { "name": "نزدیک کننده ران", "value": "15" }, { "name": "همسترینگ", "value": "16" }];
    const typeOfExercise = [{ "name": "بر اساس زمان", "value": "based_time" }, { "name": "بر اساس تکرار ", "value": "based_repetition" }];
    const hardshipLevel = [{ "name": "حرفه ای", "value": "professional" }, { "name": "نیمه حرفه ای", "value": "semiProfessional" }, { "name": "متوسط", "value": "intermediate" }, { "name": "مبتدی", "value": "beginner" }];
    const [equipments, setEquipments] = useState([]);
    const [musclesInvolved, setMusclesInvolved] = useState([]);
    const [musclesSelected, setMusclesSelected] = useState([]);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState([]);
    const WeightFilters = [{ "name": "بله", "value": true }, { "name": "خیر", "value": false }];
    const [WeightFilter, setWeightFilter] = useState(true);
    const distanceFilters = [{ "name": "بله", "value": true }, { "name": "خیر", "value": false }];
    const [distanceFilter, setdistanceFilter] = useState(true);
    const [movementImage, setMovementImage] = useState({ "id": null, "link": null });
    const [movementVideo, setMovementVideo] = useState({ "id": null, "link": null });
    const [categories, setCategories] = useState([]);
    const [updater, setUpdater] = useState(1)

    useEffect(() => {
        setLoading({ ...loading, 1: true })
        Axios.get(`${url}sports-equipments/v1/search`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    var x = [];
                    for (const iterator of response.data.docs) {
                        x.push({
                            name: iterator.title,
                            value: iterator._id
                        })
                    }
                    setData(x)
                    setLoading({ ...loading, 1: false })
                }
                else {
                    RedNotif(response.message)
                    setLoading({ ...loading, 1: false })
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });
    }, [updater])


    useEffect(() => {
        Axios.get(`${url}categories/get-category`)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {

                    var x = [];
                    for (const iterator of response.data) {
                        x.push({
                            name: iterator.title,
                            value: iterator._id
                        })
                    }
                    setCategories(x)
                }
                else {
                    RedNotif(response.message)
                    setLoading(false)
                }
            })
            .catch((error) => {
                RedNotif("سرور در حال حاضر قادر به پاسخگویی نمی باشد !")
            });

    }, [updater])



    const createMovement = () => {
        if (user.title != "" && user.title != null && user.title != undefined
            && user.typeOfExercise != "" && user.typeOfExercise != null && user.typeOfExercise != undefined
            && user.hardshipLevel != "" && user.hardshipLevel != null && user.hardshipLevel != undefined
            && user.category != "" && user.category != null && user.category != undefined
            && movementImage.id != "" && movementImage.id != null && movementImage.id != undefined
            && selected != "" && selected != null && selected != undefined
            && musclesSelected != "" && musclesSelected != null && musclesSelected != undefined) {
            setLoading({ ...loading, 1: true })

            if (WeightFilter == true && user.typeOfExercise == "based_repetition") {
                var x = {
                    "title": user.title,
                    "typeOfExercise": user.typeOfExercise,
                    "hardshipLevel": user.hardshipLevel,
                    "necessaryEquipment": selected,
                    "description": user.description,
                    "mainMusclesInvolved": musclesSelected,
                    "haveMovementWeight": true,
                    "image": movementImage.id != null ? movementImage.id : "",
                    "video": movementVideo.id != null ? movementVideo.id : "",
                    "category": user.category,

                }

                Axios.post(`${url}movements/create`, x)
                    .then(async (response) => {
                        if (response.status === 200 || response.status === 201) {
                            GreenNotif(response.message);
                            setLoading({ ...loading, 1: false })
                            setUpdater(updater + 1)
                        } else {
                            RedNotif(response.message);
                            setLoading({ ...loading, 1: false })
                        }
                    })
                    .catch((error) => {
                        RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                        console.log("error", error)
                        setLoading({ ...loading, 1: false })
                    });
            } else if (WeightFilter == false && user.typeOfExercise == "based_repetition") {

                var x = {
                    "title": user.title,
                    "typeOfExercise": user.typeOfExercise,
                    "hardshipLevel": user.hardshipLevel,
                    "necessaryEquipment": selected,
                    "mainMusclesInvolved": musclesSelected,
                    "description": user.description,
                    "haveMovementWeight": false,
                    "image": movementImage.id != null ? movementImage.id : "",
                    "video": movementVideo.id != null ? movementVideo.id : "",
                    "category": user.category,


                }

                Axios.post(`${url}movements/create`, x)
                    .then(async (response) => {
                        if (response.status === 200 || response.status === 201) {
                            GreenNotif(response.message);
                            setLoading({ ...loading, 1: false });
                            setUpdater(updater + 1)
                        } else {
                            RedNotif(response.message);
                            setLoading({ ...loading, 1: false });
                        }
                    })
                    .catch((error) => {
                        RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                        console.log("error", error)
                        setLoading({ ...loading, 1: false })
                    });
            } else if (distanceFilter == true && user.typeOfExercise == "based_time") {
                var x = {
                    "title": user.title,
                    "typeOfExercise": user.typeOfExercise,
                    "hardshipLevel": user.hardshipLevel,
                    "necessaryEquipment": selected,
                    "mainMusclesInvolved": musclesSelected,
                    "description": user.description,
                    "haveMovementWeight": true,
                    "image": movementImage.id != null ? movementImage.id : "",
                    "video": movementVideo.id != null ? movementVideo.id : "",
                    "category": user.category,


                }

                Axios.post(`${url}movements/create`, x)
                    .then(async (response) => {
                        if (response.status === 200 || response.status === 201) {
                            GreenNotif(response.message);
                            setLoading({ ...loading, 1: false })
                            setUpdater(updater + 1)
                        } else {
                            RedNotif(response.message);
                            setLoading({ ...loading, 1: false })
                        }
                    })
                    .catch((error) => {
                        RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                        console.log("error", error)
                        setLoading({ ...loading, 1: false })
                    });

            } else if (distanceFilter == false && user.typeOfExercise == "based_time") {
                var x = {
                    "title": user.title,
                    "typeOfExercise": user.typeOfExercise,
                    "hardshipLevel": user.hardshipLevel,
                    "necessaryEquipment": selected,
                    "mainMusclesInvolved": musclesSelected,
                    "description": user.description,
                    "haveMovementDistance": false,
                    "image": movementImage.id != null ? movementImage.id : "",
                    "video": movementVideo.id != null ? movementVideo.id : "",
                    "category": user.category,


                }

                Axios.post(`${url}movements/create`, x)
                    .then(async (response) => {
                        if (response.status === 200 || response.status === 201) {
                            GreenNotif(response.message);
                            setLoading({ ...loading, 1: false })
                            setUpdater(updater + 1)
                        } else {
                            RedNotif(response.message);
                            setLoading({ ...loading, 1: false })
                        }
                    })
                    .catch((error) => {
                        RedNotif("سرور قادر به پاسخ گویی نمی باشد")
                        console.log("error", error)
                        setLoading({ ...loading, 1: false })
                    });
            }

        } else {
            RedNotif("هیچ کدام از موارد نمی تواند خالی باشد")
        }
    }

    const uploadImage = async (e) => {
        setLoading({ ...loading, 2: true })

        var rsr = await Uploder(e, "image")
        if (rsr.status == 200 || rsr.status == 201) {
            setLoading({ ...loading, 2: false })
            setMovementImage({ "id": rsr.data._id, "link": `${url}${rsr.data.path}` })
        }
    }


    const uploadVideo = async (e) => {
        setLoading({ ...loading, 3: true })
        var res = await Uploder(e, "video")
        if (res.status == 200 || res.status == 201) {
            setLoading({ ...loading, 3: false })
            setMovementVideo({ "id": res.data._id, "link": `${url}${res.data.path}` })
        }
    }


    switch (loading[1]) {
        case true: return (
            <div style={{ marginTop: "80px" }}>
                <LOADING type={"lg"} />
            </div>
        )
        case false: return (
            <>
                <Row style={{ marginBottom: '18px', marginTop: "15px" }}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                        <p>اطلاعات زیر را وارد نمایید:</p>
                    </Col>
                </Row>
                <Row style={{ marginRight: '8px' }} gutter={20}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} style={{ marginBottom: '28px' }}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '16px' }}>
                            <p>نام حرکت:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>
                        </div>
                        <INPUT
                            placeholder="مثلا جلو بازو با هالتر"
                            i={(e) => setUser({ ...user, "title": e })}
                            value={user.title != undefined && user.title != null && user.title != "0" ? user.title : ""}

                        />
                    </Col>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} style={{ marginBottom: '28px' }}>
                        <div style={{ display: 'flex', padding: "0 12px", marginRight: '8px' }}>
                            <p>درجه سختی:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>
                        </div>
                        <br />
                        <SELECT
                            click={(e) => setUser({ ...user, "hardshipLevel": e })}
                            items={hardshipLevel}
                            value={user.hardshipLevel} />
                    </Col>
                </Row>


                <Row style={{ marginRight: '8px', marginTop: "16px", marginBottom: "24px" }} gutter={20}>

                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <div style={{ display: 'flex', padding: "0 12px" }}>
                            <p>نوع حرکت:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>
                        </div>
                        <br />
                        <SELECT
                            click={(e) => setUser({ ...user, "typeOfExercise": e })}
                            items={typeOfExercise}
                            value={user.typeOfExercise} />
                    </Col>

                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <div style={{ display: 'flex', padding: "0 12px", marginRight: '8px' }}>
                            <p>دسته بندی:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>
                        </div>
                        <br />
                        <SELECT
                            click={(e) => setUser({ ...user, "category": e })}
                            items={categories}
                            value={user.category}

                        />
                    </Col>

                </Row>

                {
                    user.typeOfExercise == "based_time"
                        ?
                        <>
                            <Row style={{ marginBottom: '18px' }}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                                    <p>حرکت دارای مسافت است؟</p>
                                </Col>
                            </Row>

                            <Row style={{ marginRight: '8px', marginBottom: "48px" }}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                                    <div style={{ display: 'flex', padding: "0 12px", marginRight: '8px' }}>
                                        <p style={{ color: color.primary }}></p>
                                    </div>
                                    <RADIO click={(e) => { setdistanceFilter(e) }} items={distanceFilters} defaultValue={distanceFilter} />

                                </Col>
                            </Row>

                        </>

                        : <></>
                }
                {

                    user.typeOfExercise == "based_repetition"
                        ?
                        <>
                            <Row style={{ marginBottom: '18px' }}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                                    <p>حرکت دارای وزنه است؟</p>
                                </Col>
                            </Row>

                            <Row style={{ marginRight: '8px', marginBottom: "48px" }}>
                                <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                                    <div style={{ display: 'flex', padding: "0 12px", marginRight: '8px' }}>
                                        <p style={{ color: color.primary }}></p>
                                    </div>
                                    <RADIO click={(e) => { setWeightFilter(e) }} items={WeightFilters} defaultValue={WeightFilter} />

                                </Col>
                            </Row>

                        </>
                        : <></>

                }


                <Row style={{ marginRight: '8px'}} gutter={20}>

                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} style={{ marginBottom: '28px' }}>
                        <div style={{ display: 'flex', padding: "0 12px", marginBottom: '8px' }}>
                            <p>نحوه اجرای حرکت:</p>
                        </div>
                        <TEXTROW
                            i={(e) => { setUser({ ...user, "description": e }) }}
                            value={user.description != undefined && user.description != null && user.description != "0" ? user.description : ""} />

                    </Col>

                </Row>

                <hr color= "#1890ff" />

                <Row style={{ marginRight: '8px', marginTop: "16px", marginBottom: "24px" }} gutter={20}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                        <div style={{ display: 'flex', padding: "0 12px" }}>
                            <p>تجهیزات:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>
                        </div>
                        <br />

                        <CHECKBOX
                            click={(e) => {
                                var x = equipments;
                                x.push(e)
                                setEquipments(e)
                            }}
                            items={data}
                            selectedItems={selected}
                            check={(e) => { setSelected(e) }

                            }
                        />
                    </Col>
                </Row>

                <hr color="#1890ff" />

                <Row style={{ marginRight: '8px', marginTop: "16px", marginBottom: "24px" }} gutter={20}>
                    <Col xxl={24} xl={24} lg={24} md={24} sm={24}>
                        <div style={{ display: 'flex', padding: "0 12px" }}>
                            <p>عضلات اصلی درگیر:</p>
                            <p style={{ color: color.mandatoryColor }}>*</p>
                        </div>
                        <br />

                        <CHECKBOX
                            click={(e) => {
                                var x = musclesInvolved;
                                x.push(e)
                                setMusclesInvolved(parseInt(e))
                            }}
                            items={mainMusclesInvolved}
                            selectedItems={musclesSelected}
                            check={(e) => { setMusclesSelected(e) }

                            }
                        />
                    </Col>

                </Row>

                <hr color="#1890ff"/>


                <Row style={{ marginRight: '8px', marginTop: '32px' }} gutter={20}>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                        <p style={{ margin: "15px !important" }}>تصویر حرکت </p>
                        <div style={{ width: "250px", height: '150px', margin: "10px 0" }}>
                            <UPLOAD
                                label={"up2"}
                                accept={".png,.jepg,.jpg"}
                                click={(e) => {
                                    uploadImage(e)
                                }} loading={loading[2]} defultImage={movementImage.link} />
                        </div>
                    </Col>

                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                        <p style={{ margin: "15px !important" }}>ویدئو حرکت </p>
                        <div style={{ width: "250px", height: '150px', margin: "10px 0" }}>
                            <UPLOADVIDEO
                                label={"up3"}
                                accept={".mp4,.wmv,.mkv,.avchd,.mov,.avi,.webm"}
                                click={(e) => {
                                    uploadVideo(e)
                                }} loading={loading[3]} video={movementVideo.link} />
                        </div>
                    </Col>
                </Row>


                <Row style={{ marginTop: '64px' }} gutter={20}>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12}>
                        <BUTTON event={(e) => createMovement()} text="ثبت " type={"submit"} loading={loading} />
                    </Col>
                    <Col xxl={6} xl={6} lg={6} md={6} sm={6} />
                </Row>
            </>
        )
    }

}

